module.exports = __webpack_public_path__ + "static/media/placas (7).e29ec58e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas/placas (7).jpg
// module id = 357
// module chunks = 0